/* eslint-disable quotes */
/* eslint-disable prefer-template */

import { apiPath } from "@/api/api-path"
import qs from "qs"
import api from "./service"

// New Entry
export async function getNewEntryTicket(params) {
  return api
    .get(apiPath.getNewEntry.ticket, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getNewEntrySiteAccess(params) {
  return api
    .get(apiPath.getNewEntry.siteAccess, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getNewEntrySmartHand(params) {
  return api
    .get(apiPath.getNewEntry.smartHand, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getNewEntryParcel(params) {
  return api
    .get(apiPath.getNewEntry.parcel, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getNewEntryXConnect(params) {
  return api
    .get(apiPath.getNewEntry.xConnect, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

// Recent Entry
export async function getRecentEntryTicket(params) {
  return api
    .get(apiPath.getRecentEntry.ticket, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getRecentEntrySiteAccess(params) {
  return api
    .get(apiPath.getRecentEntry.siteAccess, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getRecentEntrySmartHand(params) {
  return api
    .get(apiPath.getRecentEntry.smartHand, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getRecentEntryParcel(params) {
  return api
    .get(apiPath.getRecentEntry.parcel, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getRecentEntryXConnect(params) {
  return api
    .get(apiPath.getRecentEntry.xConnect, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getRecentEntryEscalation(params) {
  return api
    .get(apiPath.getRecentEntry.escalation, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getStatTicket(params) {
  return api
    .get(apiPath.getStat.ticket, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getStatSiteAccess(params) {
  return api
    .get(apiPath.getStat.siteAccess, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getStatSmartHand(params) {
  return api
    .get(apiPath.getStat.smartHand, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getStatParcel(params) {
  return api
    .get(apiPath.getStat.parcel, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getStatXConnect(params) {
  return api
    .get(apiPath.getStat.xConnect, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getStatContract(params) {
  return api
    .get(apiPath.getStat.contract, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getNewEntryStat(params) {
  return api
    .get(apiPath.getNewEntryStat, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getMaDate(params) {
  return api
    .get(apiPath.getMaDate, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getIdcDatabase(params) {
  return api
    .get(apiPath.getIdcDatabase, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getExecutiveTicketStat(params) {
  return api
    .get(apiPath.getExecutiveTicketStat, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getExecutiveTicketCriticalEntry(params) {
  return api
    .get(apiPath.getExecutiveTicketCriticalEntry, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getExecutiveTicketEscalation(params) {
  return api
    .get(apiPath.getExecutiveTicketEscalation, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExecutiveTicketRecentEntry(params) {
  return api
    .get(apiPath.getExecutiveTicketRecentEntry, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function getExecutiveNewEntryStat(params) {
  return api
    .get(apiPath.getExecutiveNewEntryStat, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}
